import { useParams } from "react-router-dom";
import ProjectShell from "../components/ProjectShell";
import FinancialContent from "./FinancialContent";

export default function ProjectFinancial() {
  const { id } = useParams<{ id: string }>();

  return (
    <ProjectShell projectId={id!} activeTab="financial">
      <FinancialContent projectId={id!} />
    </ProjectShell>
  );
}
